import React from "react";
import Row from "react-bootstrap/Row";
import { Container } from "react-bootstrap";

export const JobCard = ({ props, index }) => {
    if (!props) {
        return;
    }

    const {
        positionTitle,
        // link,
        reqID,
        positionNumber,
        payRate,
        closingDate,
        location,
        division,
        department,
        dateOpen,
        positionInHouse,
        rate
    } = props;

    return (
        <>
            <Container className=" ">
                <div className="card job-card job-card-color my-1 border rounded-3">
                    <div className="card-body" style={{cursor: "pointer"}}>
                        <p
                            className="visually-hidden"
                        >
                            {
                                "Job listing #" + index + ","
                                + "Position: " + positionTitle + ","
                                + "Requisition ID: " + reqID + ","
                                + "Position Number: " + positionNumber + ","
                                + "Pay rate: " + payRate + ","
                                + "Closing date: " + closingDate + ","
                                + "Location: " + location + ","
                                + "Division: " + division + ","
                                + "Department: " + department + ","
                                + "Open date " + dateOpen + ","
                                + "In house " + positionInHouse

                                + "Rate " + rate + ","

                            }
                        </p>
                        {/* <Row>
                            <Col>card-background rounded-3 shadow-sm
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    fill="currentColor"
                                    className="bi bi-building my-2 job-icon"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"
                                    />
                                    <path d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z" />
                                </svg>
                            </Col>
                        </Row> */}
                        <Row aria-hidden="true">
                            <h5 className="card-title job-sort-title border-bottom border-3 border-warning">
                                {positionTitle}{positionInHouse === "Yes" && " (In-house)"}
                            </h5>
                        </Row>
                        <h6 aria-hidden="true" className="card-subtitle my-4 text-muted job-sort-location">
                            {location}
                        </h6>

                        <p aria-hidden="true" className="card-text mb-0 job-sort-division">
                            {division}
                        </p>
                        <p aria-hidden="true" className="card-text mb-3 job-sort-department">
                            {department}
                        </p>

                        <p aria-hidden="true" className="card-text mb- 0 ">
                            <b>Position #: </b>
                            <i className="job-sort-position-number">
                                {positionNumber}
                            </i>
                        </p>
                        <p aria-hidden="true" className="card-text mb- 0 ">
                            <b>Salary: </b>
                            <i className="job-sort-position-number">
                                {payRate}
                            </i>
                        </p>
                        <p aria-hidden="true" className="card-text mb- 0 ">
                            <b>Hourly Rate: </b>
                            <i className="job-sort-position-number">
                                {rate ? `$${parseFloat(rate).toFixed(2)}` : ""}
                            </i>
                        </p>
                        <p aria-hidden="true" className="card-text ">
                            <b>Requisition ID: </b>
                            <i className="job-sort-requisition-ID">{reqID}</i>
                        </p>
                        <p aria-hidden="true" className="card-text ">
                            <b>Date Open: </b>
                            <i className="job-sort-requisition-ID">{dateOpen}</i>
                        </p>
                        {positionInHouse === "Yes" && (
                            <p aria-hidden="true" className="card-text ">
                            <b>In-house postion: </b>
                            <i className="job-sort-requisition-ID">Yes</i>
                        </p>
                        )}
                    </div>
                </div>
            </Container>
        </>
    );
};
